export type SubscriptionCategory = {
    name: string;
    label: string;
    projectTypes: string[];
    tags: SubscriptionTag[];
};

export type SubscriptionCategories = SubscriptionCategory[];

export enum SubscriptionTag {
    PROJECT = 'project',
    SURVEY = 'survey',
}

export enum FeatureType {
    SURVEY = 'SURVEY',
    HLCA = 'HLCA',
    EDNA = 'EDNA',
}
